import { Editor, Transforms } from 'slate';

const withAlignments = editor => {
	// Align list
	const ALIGNS = ['center', 'right', 'justify'];

	// Check if align is active
	editor.isAlignActive = align => {
		const [match] = Editor.nodes(editor, {
			match: node => align
				? node.style?.textAlign === align
				: ALIGNS.includes(node?.style?.textAlign)
		});
		return match?.[0]?.style?.textAlign;
	};

	// Toggle given align on selection
	editor.toggleAlign = align => {
		Transforms.setNodes(editor, {
			style: editor.isAlignActive(align)
				? undefined
				: { textAlign: align }
		});
	};

	return editor;
};

export default withAlignments;